import { Component, OnInit } from '@angular/core';
import { InviterUtilisateursModel } from 'src/models/pilotage/inviterUtilisateursModel';
import { InviteUtilisateurDialogComponent } from '../invite-utilisateur-dialog/invite-utilisateur-dialog.component';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UtilisateurService } from 'src/services/utilisateur.service';
import { SnackBarService } from 'src/services/snack-bar.service';
import { Router } from '@angular/router';
import { InviterAdminsPilotesModel } from 'src/models/pilotage/inviterAdminsPilotesModel';
import { UtilisateursDejaEnregistresDialogComponent } from '../utilisateurs-deja-enregistres-dialog/utilisateurs-deja-enregistres-dialog.component';
import { catchError, of, tap, throwError } from 'rxjs';
import { ResultInviterUtilisateursModel } from 'src/models/pilotage/resultInviterUtilisateursModel';
import { TranslateModule } from '@ngx-translate/core';

import { FormsModule } from '@angular/forms';
import { CommunInviteComponent } from '../commun-invite/commun-invite.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EtiquetteModel } from 'src/models/pilotage/contextePilotageUtilisateurModel';

@Component({
    selector: 'app-invite-admin-pilote-dialog',
    templateUrl: './invite-admin-pilote-dialog.component.html',
    styleUrls: ['./invite-admin-pilote-dialog.component.scss'],
    imports: [
    MatDialogModule,
    TranslateModule,
    FormsModule,
    CommunInviteComponent,
    MatProgressSpinnerModule
]
})
export class InviteAdminPiloteDialogComponent implements OnInit {
  etiquettesAccessibles: EtiquetteModel[] = [];
  entitesAccessibles: { id: number, nom: string, estActif?: boolean | null }[] = [];
  courriels: string[] = [];
  entiteIdVisioSelectionne!: number;
  etiquettesSelectionnees: EtiquetteModel[] = [];
  estPiloteGroupe: boolean = false;

  estInvitePilote = false;
  estInviteAdmin = false;
  inviteGroupeId: number | null = null;
  inviteEntiteAdmins: { id: number, nom: string, estActif?: boolean | null }[] = [];

  entiteIdInviteAdminSelectionnee: number | null = null;

  entitesDispoInviteAdmin: { id: number, nom: string, estActif?: boolean | null}[] = [];

  isLoading: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<InviteUtilisateurDialogComponent>,
    private dialogRefDejaEnregistres: MatDialog,
    private utilisateurService: UtilisateurService,
    public router: Router
  ) {
  }

  ngOnInit(): void {
    this.entitesAccessibles = this.utilisateurService.contexteUtilisateur.entitesAccessibles
    .filter(re => !re.estGroupe)
    .map(re => ({
      id: re.entiteId,
      nom: re.nom,
      estActif: re.estActif
    }));



    if (this.entitesAccessibles.length === 1) {
      this.entiteIdVisioSelectionne = this.entitesAccessibles[0].id;
    }

    this.estPiloteGroupe = this.utilisateurService.contexteUtilisateur.entitesAccessibles
      .filter(re => re.estGroupe).length > 0;

    this.majEntiteDispoInviteAdmin();
    this.updateAvailableEtiquettes();
  }

  private updateAvailableEtiquettes(): void {
    let availableEtiquettes = new Set<EtiquetteModel>();

    const groupEntites = this.utilisateurService.contexteUtilisateur.entitesAccessibles
      .filter(e => e.estGroupe)
      .map(e => e.entiteId);

    const groupeEtiquettes = this.utilisateurService.contexteUtilisateur.toutesLesEtiquettes
      .filter(e => e.entiteIds.some(id => groupEntites.includes(id)));

    groupeEtiquettes.forEach(e => availableEtiquettes.add(e));

    if (this.entiteIdVisioSelectionne) {
      const entiteEtiquettes = this.utilisateurService.contexteUtilisateur.toutesLesEtiquettes
        .filter(e => e.entiteIds.includes(Number(this.entiteIdVisioSelectionne)));
      entiteEtiquettes.forEach(e => availableEtiquettes.add(e));
    }

    this.etiquettesAccessibles = [...Array.from(availableEtiquettes)];
  }


  majEntiteDispoInviteAdmin(): void {
    this.entitesDispoInviteAdmin = this.entitesAccessibles.filter(
      entite => !this.inviteEntiteAdmins.some(selected => selected.id === entite.id)
    );
    this.entiteIdInviteAdminSelectionnee = null;
  }

  onEmailsChanged(courriels: string[]): void {
    this.courriels = courriels;
  }

  onEntitySelected(entiteId: number): void {
    this.entiteIdVisioSelectionne = entiteId;
    this.updateAvailableEtiquettes();
  }

  onEtiquettesSelectionnees(etiquettes: EtiquetteModel[]): void {
    this.etiquettesSelectionnees = etiquettes;
  }

  onEntiteInviteSelected(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const entiteId = Number(selectElement.value);
    const entiteSelectionne = this.entitesDispoInviteAdmin.find(e => e.id === entiteId);
    if (entiteSelectionne) {
      this.inviteEntiteAdmins.push(entiteSelectionne);
      this.majEntiteDispoInviteAdmin();
    }
  }

  onRoleChange(role: 'pilote' | 'admin'): void {
    if (role === 'pilote') {
      if (this.estInvitePilote) {
        this.estInviteAdmin = false;
        this.inviteEntiteAdmins = [];
      }
    } else {
      if (this.estInviteAdmin) {
        this.estInvitePilote = false;
        if (this.entitesAccessibles.length === 1) {
          this.inviteEntiteAdmins.push(this.entitesAccessibles[0]);
        }
      } else {
        this.inviteEntiteAdmins = [];
      }
    }
    this.majEntiteDispoInviteAdmin();
  }

  removeSelectedEntity(id: number): void {
    this.inviteEntiteAdmins = this.inviteEntiteAdmins.filter(entite => entite.id !== id);
    this.majEntiteDispoInviteAdmin();
    this.updateAvailableEtiquettes();
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit(): void {
    this.isLoading = true;
    const inviterAdmins: InviterAdminsPilotesModel = {
      courriels: this.courriels,
      entiteVisioId: this.entiteIdVisioSelectionne,
      groupePiloteId: this.estInvitePilote ? this.utilisateurService.contexteUtilisateur.entitesAccessibles.find(re => re.estGroupe)?.entiteId! : null,
      entiteAdminIds: this.estInviteAdmin ? this.inviteEntiteAdmins.map(er => er.id) : [],
      etiquetteIds: this.etiquettesSelectionnees.map(e => e.etiquetteId)
    };

    this.utilisateurService.inviterAdminsPilotes(inviterAdmins).pipe(
      tap((response: ResultInviterUtilisateursModel) => {
        if (response) {
          this.dialogRefDejaEnregistres.open(UtilisateursDejaEnregistresDialogComponent, {
            data: response
          });
        }
      }),
      catchError((error) => {
        console.error('Erreur lors de l\'invitation des utilisateurs', error);
        return throwError(() => error);
      })
    ).subscribe({
      next: () => {
        this.isLoading = false;
        this.dialogRef.close(true);
      },
      error: () => {
        this.isLoading = false;
        this.dialogRef.close(false);
      }
    });
  }
}
